export const SET_ACCOUNT_NAME = 'SET_ACCOUNT_NAME';

export const setAccountName = account => ({
  type: SET_ACCOUNT_NAME,
  payload: account
});
